import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseD = props => <ServerComponentCaller url={"assets/data/pages/licencias/D.json"}/>;

export default LicenciaClaseD;
